import React, { useState, useEffect } from "react";
import classnames from "classnames";
import BackgroundVideo from "../components/Background-Video";
import BackButton from "../partials/Back-Button";
import {motion} from "framer-motion";
import Videos from "../video/101160_SCS_Interactive_Sc9_4K_10s_V1.mp4";

const ConstructionProductivity = () => {
  const [activeDot, setActiveDot] = useState("");
  const [dotOneX, setDotOneX] = useState();
  const [dotOneY, setDotOneY] = useState();
  const [blobOneX, setBlobOneX] = useState();
  const [blobOneY, setBlobOneY] = useState();
  const [dotTwoX, setDotTwoX] = useState();
  const [dotTwoY, setDotTwoY] = useState();
  const [blobTwoX, setBlobTwoX] = useState();
  const [blobTwoY, setBlobTwoY] = useState();
  const [dotThreeX, setDotThreeX] = useState();
  const [dotThreeY, setDotThreeY] = useState();
  const [blobThreeX, setBlobThreeX] = useState();
  const [blobThreeY, setBlobThreeY] = useState();
  const [dotFourX, setDotFourX] = useState();
  const [dotFourY, setDotFourY] = useState();
  const [blobFourX, setBlobFourX] = useState();
  const [blobFourY, setBlobFourY] = useState();
  const [dotFiveX, setDotFiveX] = useState();
  const [dotFiveY, setDotFiveY] = useState();
  const [blobFiveX, setBlobFiveX] = useState();
  const [blobFiveY, setBlobFiveY] = useState();

  const getPosition = () => {
    const dotOne = document.getElementById("dotOne").getBoundingClientRect();
    const dotOneTop = dotOne.top;
    const dotOneLeft = dotOne.left;

    setDotOneX(dotOneLeft + 21.5);
    setDotOneY(dotOneTop + 21.5);

    const blobOne = document.getElementById("blobOne").getBoundingClientRect();
    const blobOneTop = blobOne.top;
    const blobOneLeft = blobOne.left;

    setBlobOneX(blobOneLeft);
    setBlobOneY(blobOneTop);

    const dotTwo = document.getElementById("dotTwo").getBoundingClientRect();
    const dotTwoTop = dotTwo.top;
    const dotTwoLeft = dotTwo.left;

    setDotTwoX(dotTwoLeft + 21.5);
    setDotTwoY(dotTwoTop + 21.5);

    const blobTwo = document.getElementById("blobTwo").getBoundingClientRect();
    const blobTwoTop = blobTwo.top;
    const blobTwoLeft = blobTwo.left;

    setBlobTwoX(blobTwoLeft);
    setBlobTwoY(blobTwoTop);

    const dotThree = document
        .getElementById("dotThree")
        .getBoundingClientRect();
    const dotThreeTop = dotThree.top;
    const dotThreeLeft = dotThree.left;

    setDotThreeX(dotThreeLeft + 21.5);
    setDotThreeY(dotThreeTop + 21.5);

    const blobThree = document
        .getElementById("blobThree")
        .getBoundingClientRect();
    const blobThreeTop = blobThree.top;
    const blobThreeLeft = blobThree.left;

    setBlobThreeX(blobThreeLeft);
    setBlobThreeY(blobThreeTop);

    const dotFour = document.getElementById("dotFour").getBoundingClientRect();
    const dotFourTop = dotFour.top;
    const dotFourLeft = dotFour.left;

    setDotFourX(dotFourLeft + 21.5);
    setDotFourY(dotFourTop + 21.5);

    const blobFour = document.getElementById("blobFour").getBoundingClientRect();
    const blobFourTop = blobFour.top;
    const blobFourLeft = blobFour.left;

    setBlobFourX(blobFourLeft);
    setBlobFourY(blobFourTop);

    const dotFive = document.getElementById("dotFive").getBoundingClientRect();
    const dotFiveTop = dotFive.top;
    const dotFiveLeft = dotFive.left;

    setDotFiveX(dotFiveLeft + 21.5);
    setDotFiveY(dotFiveTop + 21.5);

    const blobFive = document.getElementById("blobFive").getBoundingClientRect();
    const blobFiveTop = blobFive.top;
    const blobFiveLeft = blobFive.left;

    setBlobFiveX(blobFiveLeft);
    setBlobFiveY(blobFiveTop);

  };

  useEffect(() => {
    getPosition();
  }, []);

  return (
      <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4 }}
          className="w-screen h-[calc(100vh-172px)] relative top-[172px] left-0">
        <BackButton backurl="/cyber-recovery" />
        <BackgroundVideo
            fullscreen
            video={Videos}
        />
        <div className="w-screen h-[calc(100vh-172px)] relative ">
          <div className=" bg-opacity-50 backdrop-blur-md bg-white w-[380px] 2xl:w-[740px] py-7 px-9 2xl:py-14 2xl:px-[59px] rounded-3xl relative left-10 -top-[50px] 2xl:-top-[30px] 2xl:top-5 mr-auto zoom-8">
            <h1 className="font-semibold uppercase text-dell-blue font-proxima-nova text-lg 2xl:text-[25px] 2xl:leading-[30px] pb-3">
              RETAIL OPERATION
            </h1>
            <p className="font-proxima-nova text-[#444444] text-xl 2xl:text-[30px] 2xl:leading-[37px] font-thin">
              Grow your network utilization and managed services business, as well as gain access to data center spend while providing protection and timely recovery of your retail customer’s most critical data.
            </p>
          </div>

          <svg
              className={classnames(
                  "fixed top-0 transition-all duration-300 ",
                  activeDot === 1 ? "opacity-100 delay-75" : "opacity-0"
              )}
              width="100vw"
              height="100vh"
          >
            <line
                x1={dotOneX}
                y1={dotOneY}
                x2={blobOneX}
                y2={blobOneY}
                stroke="#444444"
                strokeDasharray="15 15"
            />
          </svg>

          <svg
              className={classnames(
                  "fixed top-0 transition-all duration-300 ",
                  activeDot === 2 ? "opacity-100 delay-75" : "opacity-0"
              )}
              width="100vw"
              height="100vh"
          >
            <line
                x1={dotTwoX}
                y1={dotTwoY}
                x2={blobTwoX}
                y2={blobTwoY}
                stroke="#444444"
                strokeDasharray="15 15"
            />
          </svg>

          <svg
              className={classnames(
                  "fixed top-0 transition-all duration-300 ",
                  activeDot === 3 ? "opacity-100 delay-75" : "opacity-0"
              )}
              width="100vw"
              height="100vh"
          >
            <line
                x1={dotThreeX}
                y1={dotThreeY}
                x2={blobThreeX}
                y2={blobThreeY}
                stroke="#444444"
                strokeDasharray="15 15"
            />
          </svg>
          <svg
              className={classnames(
                  "fixed top-0 transition-all duration-300 ",
                  activeDot === 3 ? "opacity-100 delay-75" : "opacity-0"
              )}
              width="100vw"
              height="100vh"
          >
            <line
                x1={dotThreeX}
                y1={dotThreeY}
                x2={blobThreeX}
                y2={blobThreeY}
                stroke="#444444"
                strokeDasharray="15 15"
            />
          </svg>
          <svg
              className={classnames(
                  "fixed top-0 transition-all duration-300 ",
                  activeDot === 4 ? "opacity-100 delay-75" : "opacity-0"
              )}
              width="100vw"
              height="100vh"
          >
            <line
                x1={dotFourX}
                y1={dotFourY}
                x2={blobFourX}
                y2={blobFourY}
                stroke="#444444"
                strokeDasharray="15 15"
            />
          </svg>
          <svg
              className={classnames(
                  "fixed top-0 transition-all duration-300 ",
                  activeDot === 5 ? "opacity-100 delay-75" : "opacity-0"
              )}
              width="100vw"
              height="100vh"
          >
            <line
                x1={dotFiveX}
                y1={dotFiveY}
                x2={blobFiveX}
                y2={blobFiveY}
                stroke="#444444"
                strokeDasharray="15 15"
            />
          </svg>

          <div className="edge-dots absolute w-screen h-[calc(100vh-172px)] top-0 grid grid-cols-5 grid-rows-3">
            <div></div>
            <div></div>
            <div className="relative flex justify-center items-center">
              <div
                  id="dotOne"
                  className="dot absolute rounded-full w-[30px] h-[30px] 2xl:w-[43px] 2xl:h-[43px]  bg-[#6E2585] border-2 cursor-pointer"
                  onMouseEnter={() => setActiveDot(1)}
                  onMouseLeave={() => setActiveDot("")}
                  onKeyUp={() => setActiveDot(1)}
                  onKeyDown={() => setActiveDot("")}
                  tabIndex={0}
              ></div>
              <div
                  id="blobOne"
                  className={classnames(
                      "absolute top-32 right-32 px-12 text-center flex flex-col justify-center items-center rounded-full bg-[#6E2585] text-white min-w-[360px] h-[360px] transition-all duration-300 ",
                      activeDot === 1
                          ? "opacity-100 scale-75 2xl:scale-100 z-50"
                          : "opacity-0 scale-0"
                  )}
              >
                <p className=" text-[25px] leading-[30px] text-white font-proxima-nova font-semibold pb-4">
                  Securing Data &<br/>
                  Applications:
                </p>
                <p className=" text-[20px] leading-[24px] font-thin">
                  The IT department has<br/>
                  protected clean copies of<br/>
                  critical data and<br/>
                  applications in the air-<br/>
                  gapped vault managed by<br/>
                  the communication<br/>
                  service provider.
                </p>
              </div>
            </div>
            <div></div>
            <div className="relative flex justify-center items-end">
              <div
                  id="dotTwo"
                  className="dot absolute rounded-full w-[30px] h-[30px] 2xl:w-[43px] 2xl:h-[43px]  bg-[#6E2585] border-2 left-[0] cursor-pointer"
                  onMouseEnter={() => setActiveDot(2)}
                  onMouseLeave={() => setActiveDot("")}
                  onKeyUp={() => setActiveDot(2)}
                  onKeyDown={() => setActiveDot("")}
                  tabIndex={0}
              ></div>
              <div
                  id="blobTwo"
                  className={classnames(
                      "absolute right-[30em] top-0 px-12 text-center flex flex-col justify-center items-center rounded-full bg-[#6E2585] text-white min-w-[475px] h-[475px] transition-all duration-300",
                      activeDot === 2
                          ? "opacity-100 scale-75 2xl:scale-100 z-50"
                          : "opacity-0 scale-0"
                  )}
              >
                <p className=" text-[25px] leading-[30px] text-white font-proxima-nova font-semibold pb-4">
                  Protect & Restore:
                </p>
                <p className=" text-[20px] leading-[24px] font-extralight">
                  When a breach occurs, the<br/>
                  communication service provider, in<br/>
                  partnership with the store’s IT<br/>
                  department, can restore the protected<br/>
                  data and applications from the offline<br/>
                  cyber vault.
                  <br/>
                  <br/>
                  As a trusted third party, the<br/>
                  communication service provider,<br/>
                  performs monitoring of the vault and<br/>
                  helps with a swift recovery using their<br/>
                  network connectivity.
                </p>
              </div>
            </div>

            <div className="relative flex justify-end items-end">
              <div
                  id="dotThree"
                  className="dot absolute rounded-full w-[30px] h-[30px] 2xl:w-[43px] 2xl:h-[43px]  bg-[#6E2585] bottom-12 right-20 border-2 cursor-pointer"
                  onMouseEnter={() => setActiveDot(3)}
                  onMouseLeave={() => setActiveDot("")}
                  onKeyUp={() => setActiveDot(3)}
                  onKeyDown={() => setActiveDot("")}
                  tabIndex={0}
              ></div>

              <div
                  id="blobThree"
                  className={classnames(
                      "absolute left-64 bottom-24 px-12 text-center flex flex-col justify-center items-center rounded-full bg-[#6E2585] text-white min-w-[314px] h-[314px] transition-all duration-300",
                      activeDot === 3
                          ? "opacity-100 scale-75 2xl:scale-100 z-50"
                          : "opacity-0 scale-0"
                  )}
              >
                <p className=" text-[25px] leading-[30px] text-white font-proxima-nova font-semibold pb-4">
                  Point-of-sale:
                </p>
                <p className=" text-[20px] font-proxima-nova leading-[24px] font-thin">
                  Critical applications for<br/>
                  running the business<br/>
                  need to be functioning<br/>
                  and up to date with the<br/>
                  most current data.
                </p>
              </div>
            </div>
            <div className="relative flex justify-start items-end">
              <div
                  id="dotFour"
                  className="dot absolute rounded-full w-[30px] h-[30px] 2xl:w-[43px] 2xl:h-[43px]  bg-[#6E2585] bottom-[55px] left-[50px] border-2 cursor-pointer"
                  onMouseEnter={() => setActiveDot(4)}
                  onMouseLeave={() => setActiveDot("")}
                  onKeyUp={() => setActiveDot(4)}
                  onKeyDown={() => setActiveDot("")}
                  tabIndex={0}
              ></div>

              <div
                  id="blobFour"
                  className={classnames(
                      "absolute left-24 px-12 text-center flex flex-col justify-center items-center rounded-full bg-[#6E2585] text-white min-w-[340px] h-[340px] transition-all duration-300",
                      activeDot === 4
                          ? "opacity-100 scale-75 2xl:scale-100 z-50"
                          : "opacity-0 scale-0"
                  )}
              >
                <p className=" text-[25px] leading-[30px] text-white font-proxima-nova font-semibold pb-4">
                  Inventory:
                </p>
                <p className="text-[20px] leading-[24px] font-thin">
                  Access to accurate inventory<br/>
                  data and ordering systems is<br/>
                  required to minimize business<br/>
                  disruptions and ensure<br/>
                  orders are fulfilled for<br/>
                  customer satisfaction.
                </p>
              </div>
            </div>
            <div></div>

            <div></div>
            <div className="relative flex justify-start items-end">
              <div
                  id="dotFive"
                  className="dot absolute rounded-full w-[30px] h-[30px] 2xl:w-[43px] 2xl:h-[43px]  bg-[#6E2585] border-2 cursor-pointer"
                  onMouseEnter={() => setActiveDot(5)}
                  onMouseLeave={() => setActiveDot("")}
                  onKeyUp={() => setActiveDot(5)}
                  onKeyDown={() => setActiveDot("")}
                  tabIndex={0}
              ></div>

              <div
                  id="blobFive"
                  className={classnames(
                      "absolute right-80  px-12 text-center flex flex-col justify-center items-center rounded-full bg-[#6E2585] text-white min-w-[313px] h-[313px] transition-all duration-300",
                      activeDot === 5
                          ? "opacity-100 scale-75 2xl:scale-100 z-50"
                          : "opacity-0 scale-0"
                  )}
              >
                <p className=" text-[25px] leading-[30px] text-white font-proxima-nova font-semibold pb-4">
                  Customer Data:
                </p>
                <p className=" text-[20px] leading-[24px] font-extralight">
                  Customers’ purchase history, stored credit cards and loyalty program information can be<br/>kept secure.
                </p>
              </div>
            </div>


          </div>
        </div>
      </motion.div>
  );
};

export default ConstructionProductivity;
